import React from 'react';
import styled from 'styled-components';
import { AttachmentApi } from '../../api/attachment.api';
import { Flex } from '../atoms';

const StyledA = styled.a`
  text-decoration: none;
  &:hover {
    color: #ffffff;
    text-decoration: none;
  }
`;

const StyledDiv = styled.div`
  word-break: break-all;
  word-wrap: break-word;
  margin: 15px;
  text-align: center;
`;

const StyledSpan = styled.span`
  color: ${(props: { disabled: boolean }) =>
    props.disabled ? '#747474' : '#ffffff'};
  margin-right: 15px;
  ${(props: { disabled: boolean }) =>
    props.disabled ? `` : `text-decoration: none;`};
`;

const IconStyledDiv = styled.div`
  color: #747474;
  font-size: 24px;
  margin-left: 15px;
  height: 28px;
  margin-top: -5px;
`;

interface Props {
  attachment: {
    fileName: string;
    fileId?: string;
  };
  disabled: boolean;
  isWide: boolean;
}

export const PreviewModalAttachmentLabel = (props: Props) => {
  const { attachment, disabled, isWide } = props;
  const fileId = attachment.fileId ? attachment.fileId : '';

  return (
    <StyledA
      download={attachment.fileName}
      onClick={async (event) => {
        AttachmentApi.downloadAttachment(fileId, attachment.fileName);
      }}
    >
      <StyledDiv>
        <Flex center={isWide} full={!isWide} middle>
          <StyledSpan disabled={disabled}>{attachment.fileName}</StyledSpan>
          <IconStyledDiv>
            <img
              src="/images/download_white.png"
              alt=""
              width="25"
              height="25"
            />
          </IconStyledDiv>
        </Flex>
      </StyledDiv>
    </StyledA>
  );
};
